import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const ITEMS = [
  {
    q: "Is Stable-ish a replacement for clinical judgment?",
    a: "No. Absolutely not. Stable-ish is a reference and recall assistant — it surfaces evidence-based answers fast. Every clinical decision must still go through your training, your charge nurse, your physician, and your institutional protocols.",
  },
  {
    q: "Where does the clinical information come from?",
    a: "Stable-ish answers are grounded in current, authoritative public sources: published clinical practice guidelines (AHA/ACLS, PALS, ATLS, ENA TNCC, SCCM critical care guidelines), NIH and CDC clinical references, the Cochrane Library, peer-reviewed literature from journals like JAMA, NEJM, Annals of Emergency Medicine, Critical Care Medicine, EMCrit, and other authoritative clinical references. Every single answer ships with its source references cited inline — no claim goes unsourced — so you can verify the evidence before you act on it.",
  },
  {
    q: "Does it store patient data?",
    a: "No PHI — ever. Stable-ish is designed for de-identified queries only — please don't enter patient names, MRNs, or anything that could identify a specific patient. We're building safeguards that help reduce identifying details in queries, but the safeguards are not guaranteed to catch everything, so the responsibility to phrase questions generically stays with the user. Conversations are kept locally on your device whenever possible, and nothing tied to a specific patient is retained. Stable-ish is not a HIPAA-covered service.",
  },
  {
    q: "Who is it for?",
    a: "ER nurses, ICU nurses, rapid response teams, flight & critical care transport, and nursing students preparing for CCRN/CEN. If your shift involves codes, drips, or decisions under pressure — it's for you.",
  },
  {
    q: "Is it available now?",
    a: "Yes — Stable-ish is live on the iOS App Store with a 14-day free trial. Android is on the roadmap; sign up for the newsletter in the footer to hear when it drops.",
  },
  {
    q: "How much does it cost?",
    a: "14-day free trial, then $9.99/month or $79.99/year. Subscribe during our launch as a Founding Member and your rate is locked in for the lifetime of your subscription — even after we raise prices for new users.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-28 md:py-36 bg-[#050505] border-t border-white/5"
    >
      <div className="max-w-[1100px] mx-auto px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 mb-14">
          <div className="lg:col-span-5">
            <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#FF2A2A] mb-4">
              § 05 · the fine print
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[0.95]">
              Honest <br />
              <span className="italic font-light">answers,</span>
              <br />
              honestly.
            </h2>
          </div>
          <div className="lg:col-span-7">
            <Accordion
              type="single"
              collapsible
              className="border-t border-white/10"
              data-testid="faq-accordion"
            >
              {ITEMS.map((item, i) => (
                <AccordionItem
                  value={`item-${i}`}
                  key={i}
                  className="border-b border-white/10"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="text-left font-display text-lg md:text-xl font-bold tracking-tight hover:no-underline hover:text-[#FF2A2A] py-6 [&[data-state=open]>svg]:text-[#FF2A2A]">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[15px] text-white/65 leading-relaxed pb-6 pr-8">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
